import PropTypes from 'prop-types'
import React from "react"

import { Route, Routes, Navigate } from "react-router-dom"
import { connect } from "react-redux"

// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes"

// Import all middleware
import Authmiddleware from "./routes/route"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
//import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"
// Import scss
import "./assets/scss/theme.scss"

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

//import fakeBackend from "./helpers/AuthType/fakeBackend"

// Activating fake backend
//fakeBackend()

// const firebaseConfig = {
//   apiKey: process.env.                      ,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)

const App = () => {

  function getLayout() {
    let layoutCls = VerticalLayout
   
    return layoutCls
  }
  const Layout = getLayout()
  if (process.env.REACT_APP_BRANCH === 'production') {
    console.log = () => {}
    console.error = () => {}
    console.debug = () => {}
  }
  return (
        <Routes>
          {publicRoutes.map((route, idx) => (
            <Route
            path={route.path}
            element={
              <NonAuthLayout>
              {React.createElement(route.component)}
            </NonAuthLayout>
            }
            key={idx}
            exact={true}
          />
          ))}

          {authProtectedRoutes.map((route, idx) => (
            

            <Route
            path={route.path}
            element={
              <Authmiddleware>
                  <Layout>{React.createElement(route.component)}</Layout>
               </Authmiddleware>}
            key={idx}
            exact={true}
          />
          ))}
          <Route path="*" element={<Navigate to="/pages-404" />} />
        </Routes>
  )
}

App.propTypes = {
  layout: PropTypes.any
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
